
import { instantiate } from './qytqwasm-APPS.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


